import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const AddSubModal = ({
  open,
  onClose,
  title = "Add Round",
  items = [],
  onAdd,
  onDelete,
}) => {
  const [newItemName, setNewItemName] = useState("");

  const handleSave = async () => {
    if (!newItemName.trim()) {
      alert("Please enter a name");
      return;
    }

    try {
      if (onAdd) {
        await onAdd(newItemName);
      }
      setNewItemName("");
      onClose();
    } catch (error) {
      console.error("Error adding item:", error);
      alert("Error adding item. Please try again.");
    }
  };

  const handleDelete = async (item) => {
    try {
      if (onDelete) {
        console.log("Deleting item:", item);
        await onDelete(item);
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      alert("Error deleting item. Please try again.");
    }
  };

  const handleClose = () => {
    setNewItemName("");
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          bgcolor: "#ffffff",
          boxShadow: 24,
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: 2,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "#212121",
              fontWeight: 500,
            }}
          >
            {title}
          </Typography>
          <Button
            onClick={handleClose}
            sx={{
              color: "#757575",
              minWidth: "auto",
              p: 1,
              "&:hover": {
                bgcolor: "#f5f5f5",
              },
            }}
          >
            ✕
          </Button>
        </Box>

        {/* Content */}
        <Box sx={{ p: 2 }}>
          {/* Table */}
          {items.length > 0 && (
            <Box sx={{ mb: 3 }}>
              <Table sx={{ bgcolor: "#f5f5f5" }}>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#424242",
                        fontWeight: 500,
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      #
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#424242",
                        fontWeight: 500,
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      Items
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        color: "#424242",
                        fontWeight: 500,
                        borderBottom: "1px solid #e0e0e0",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((item, index) => (
                    <TableRow key={item.id || index}>
                      <TableCell sx={{ color: "#424242" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell sx={{ color: "#424242" }}>
                        {item.name || item.title || item}
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          variant="outlined"
                          size="small"
                          startIcon={<DeleteIcon />}
                          onClick={() => handleDelete(item)}
                          sx={{
                            borderColor: "#e0e0e0",
                            color: "#757575",
                            "&:hover": {
                              borderColor: "#bdbdbd",
                              bgcolor: "#f5f5f5",
                            },
                            textTransform: "none",
                          }}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          )}

          {/* Add new item form */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="body1"
              sx={{
                color: "#212121",
                mb: 1,
              }}
            >
              Item <span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              size="small"
              placeholder="Item Name"
              value={newItemName}
              onChange={(e) => setNewItemName(e.target.value)}
              sx={{
                bgcolor: "#f9f9f9",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#e0e0e0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#bdbdbd",
                  },
                },
                "& .MuiInputBase-input": {
                  color: "#424242",
                },
              }}
            />
          </Box>

          {/* Action buttons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              onClick={handleClose}
              sx={{
                color: "#757575",
                textTransform: "none",
                "&:hover": {
                  bgcolor: "#f5f5f5",
                },
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                bgcolor: "#4285F4",
                color: "white",
                textTransform: "none",
                "&:hover": {
                  bgcolor: "#3367D6",
                },
              }}
            >
              ✓ Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddSubModal;
